import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const EMPTY = { name: "", mobile: "", email: "", company_name: "", met_at: "", comments: "" };

export default function EventContactFormDialog({ open, onOpenChange, onCreated }) {
  const [form, setForm] = useState(EMPTY);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) setForm(EMPTY);
  }, [open]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async () => {
    if (!form.name) {
      toast.error("Name is required");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/event-contacts", form);
      toast.success("Contact saved");
      onOpenChange(false);
      onCreated?.();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="event-contact-form-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Add Event Contact</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label>Name</Label>
              <Input data-testid="event-contact-form-name-input" value={form.name} onChange={set("name")} placeholder="Full name" />
            </div>
            <div className="space-y-1.5">
              <Label>Mobile</Label>
              <Input data-testid="event-contact-form-mobile-input" value={form.mobile} onChange={set("mobile")} placeholder="+91 XXXXX XXXXX" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-1.5">
              <Label>Email</Label>
              <Input data-testid="event-contact-form-email-input" type="email" value={form.email} onChange={set("email")} placeholder="name@company.com" />
            </div>
            <div className="space-y-1.5">
              <Label>Company Name</Label>
              <Input data-testid="event-contact-form-company-input" value={form.company_name} onChange={set("company_name")} placeholder="Company" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label>Met At (Event / Conference)</Label>
            <Input data-testid="event-contact-form-metat-input" value={form.met_at} onChange={set("met_at")} placeholder="e.g. Sustainability Summit 2026" />
          </div>
          <div className="space-y-1.5">
            <Label>Comments</Label>
            <Textarea data-testid="event-contact-form-comments-input" value={form.comments} onChange={set("comments")} rows={3} placeholder="Notes about this person / follow-up plan" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="event-contact-form-cancel-button">Cancel</Button>
          <Button onClick={handleSubmit} disabled={submitting} data-testid="event-contact-form-submit-button" className="bg-[#76C121] hover:bg-[#5C9819] text-white">
            {submitting ? "Saving..." : "Save Contact"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
